module.exports = __webpack_public_path__ + "img/swiper3.76de659a.jpg";